var _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackEmoji2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3776,
    cy: 37.9869,
    r: 36.5972,
    stroke: "#27ABB3",
    strokeWidth: 2.77953
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4802,
    cy: 29.6483,
    r: 4.63256,
    fill: "#27ABB3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.2771,
    cy: 29.6483,
    r: 4.63256,
    fill: "#27ABB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8125 50.9581C50.886 47.8697 46.902 41.693 38.3781 41.693C29.8542 41.693 25.5614 47.8697 24.4805 50.9581",
    stroke: "#27ABB3",
    strokeWidth: 2.77953
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackEmoji2);
export default __webpack_public_path__ + "static/media/Feedback_emoji_2.20e9ad5ab82d4db6e63ef1e8e63117be.svg";
export { ForwardRef as ReactComponent };